
/**
 *
 * @Description: 引入一些公用的组件
 * @Params:
 * @author: liwei
 * @date:  2021/6/18 17:00
 * @version V1.0
*/

import Vue from 'vue';

// 面包屑
Vue.component('crumbs-nav', () => import('@/components/common/crumbs-nav/index.vue'));
// footer 组件
Vue.component('cc-footer', () => import('@/components/common/cc-footer/index.vue'));



// WEBPACK FOOTER //
// ./src/components/index.js